import { Invoice } from './Invoice';
import { InvoiceCount } from './InvoiceCount';

/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
export class InvoiceGlobal {

    invoicesData: Invoice[];
    invoicesCountData: InvoiceCount[];
    
    preInvoicesEmitidasData: Invoice[];
    preInvoicesEmitidasCountData: InvoiceCount[];
    
    invoicesEmitidasData: Invoice[];
    invoicesEmitidasCountData: InvoiceCount[];
    
    invoicesRecibidasData: Invoice[];
    
    numeroComprobantesEmitidos: number;
    maximoComprobantes: number;
    numeroComprobantesPorEmitir: number;
    minimoComprobantesAlertarRecarga:number;
    puedeFacturarPorPlan: boolean;
    mostrarAlertaRecarga: boolean;
}